/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('plugins/chatmapper-debug/chatmapper-debug',['require','jquery','underscore','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  var Marionette = require('marionette');

  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });

  var ScenarioVariable;
  require(['screens/scenario-mapper/scenario-variable'], function(a) {
    ScenarioVariable = a;
  });
  var ScenarioItem;
  require(['screens/scenario-mapper/scenario-item'], function(a) {
    ScenarioItem = a;
  });
  var ScenarioLocation;
  require(['screens/scenario-mapper/scenario-location'], function(a) {
    ScenarioLocation = a;
  });
  var ScenarioUtils;
  require(['screens/scenario-mapper/scenario-utils'], function(a) {
    ScenarioUtils = a;
  });

  /*****************************************************************************************************************///}

  var ChatmapperDebug = Marionette.Object.extend({

    /////////////////
    // PROPERTIES //{
    /////////////////

    built: false,
    element: null,
    scenario: null,
    mapperHolder: null,
    mapperObj: null,
    refreshBtn: null,
    abort: false,

    /*****************************************************************************************************************///}

    //////////////////
    // CONSTRUCTOR //{
    //////////////////

    initialize: function()
    {
      this.templates = { };
    },

    initializeVars: function()
    {
      this._ = this._cWindow._;
      this.$ = this._cWindow.$;
      this.refreshBtn = this.$(this._cWindow.document).find('.refresh-btn');
      this.refreshBtn.on('click', this.$.proxy(this.buildMapper, this));
    },

    checkWin: function(__callback)
    {
      var __winOpen = (this._cWindow && !this._cWindow.closed);

      if (!__winOpen)
      {
        this._cWindow = window.open('plugins/chatmapper-debug/chatmapper-debug.html', 'chat-debug', 'resizable=no, width=400px, height=800px');
        window.onunload = $.proxy(this.closeDebugWin, this);

        if (!this._cWindow) // blocked
        {
          console.error('debug window blocked');
          return 'blocked';
        }

        if (this._cWindow.document && this._cWindow.document.title === 'Chatmapper Debug')
        {
          __winOpen = true;
          this._cWindow.onunload = $.proxy(function() {this._cWindow = null; this.d3 = null; this.ready = null;}, this);
        }
        else
        {
          this._cWindow.onload = $.proxy(function() {
            this._cWindow.onunload = $.proxy(function() {this._cWindow = null; this.d3 = null; this.ready = null;}, this);
            this.openDebug();
          }, this);
        }
      }

      return __winOpen;
    },

    closeDebugWin: function()
    {
      if (this._cWindow && !this._cWindow.closed)
        this._cWindow.close();
    },

    openDebug: function($scenario)
    {
      if (this.abort)
      {
        this.abort = false;
        return;
      }

      this.scenario = $scenario || this.scenario;
      this.lastUpdateNode = null;
      var $result = this.checkWin();
      ////console.log($result);
      if ($result === 'blocked')
      {
        return;
      }
      else if (!$result)
      {
        _.delay($.proxy(this.openDebug, this, $scenario), 500);
        return;
      }

      this.initializeVars();
      this.buildMapper();
    },

    abortMapper: function()
    {
      console.warn('no scenario found, aborting debug');
      if (this._cWindow)
        this._cWindow.onunload = null;

      this.closeDebugWin();
      this.abort = true;
      this._cWindow = null;
      this.d3 = null;
      this.ready = null;
    },

    buildMapper: function()
    {
      console.warn('chatmapperdebug::buildmapper');

      if (!this._cWindow || this._cWindow.closed)
        return;

      //console.warn('this._cWindow', this._cWindow);

      this.mapperHolder = this.$(this._cWindow.document).find('#debug-container');

      this.clearMapper();
      //var $paddingY = 3;
      //350 width

      if (!Scenario || !Scenario.singleton)
      {
        this.abortMapper();
        return false;
      }

      var $remap = this._.transform(Scenario.singleton.vars, function(result, n, key) {
        if (typeof(n) === 'string')
        {
          result[key] = {name: key, currentValue: n, initialValue: n, id: key, keyName: key};
        }
        else
        {
          n.keyName = key;
          result[key] = n;
        }
      });

      var $varArr = this._.sortBy(this._.toArray($remap), 'keyName');
      var $itemArr = this._.sortBy(ScenarioItem.instancesArr, 'name');
      var $locArr = this._.sortBy(ScenarioLocation.instancesArr, 'name');

      this.buildMapperHeader('Mission Variables:', '#debug-vars');
      this.buildMapperHeader('Mission Assets (items):', '#debug-items');
      this.buildMapperHeader('Mission Activities (locations):', '#debug-locations');

      var $varMC;
      var $itemMC;
      var $locMC;

      this.mapperObj.vars = [];
      this.mapperObj.items = [];
      this.mapperObj.locations = [];

      //$varHeader.y = this.mapperHolder.height;
      //this.mapperHolder.addChild($varHeader);
      var $var;
      var $item;
      var $loc;
      var i;

      //console.log('build mapper vars');
      for (i in $varArr)
      {
        $var = $varArr[i];
        $varMC = this.buildMapperVar($var);
        //$varMC.y = this.mapperHolder.height + $paddingY;
        $item = this.$(this._cWindow.document.getElementById('vars-container'));
        $item.append($varMC);
        this.mapperObj.vars.push($varMC);
      }
      //console.log('vars built');
      //$itemHeader.y = this.mapperHolder.height + $paddingY;
      //this.mapperHolder.addChild($itemHeader);
      //console.log('build items');
      for (i in $itemArr)
      {
        $item = $itemArr[i];
        $itemMC = this.buildMapperItem($item);
        //$itemMC.y = this.mapperHolder.height + $paddingY;

        this.mapperHolder.find('#debug-items .child-container').append($itemMC);
        this.mapperObj.items.push($itemMC);
      }
      //console.log('items built');
      //$locHeader.y = this.mapperHolder.height + $paddingY;
      //this.mapperHolder.addChild($locHeader);
      //console.log('build locations');
      for (i in $locArr)
      {
        $loc = $locArr[i];
        $locMC = this.buildMapperLocation($loc);
        //$locMC.y = this.mapperHolder.height + $paddingY;

        this.mapperHolder.find('#debug-locations .child-container').append($locMC);
        this.mapperObj.locations.push($locMC);
      }
      //console.log('locations built');
      this.mapperHolder.find('.tab-btn').on('click', this.onTabClickHandler.bind(this));
      this.mapperHolder.find('[data-tab=locations]').trigger('click');
      //console.log('all built, click triggerd');
      this.built = true;
      this.updateMapper();
    },

    onTabClickHandler: function($e)
    {
      var $btn = this.$($e.currentTarget);
      this.mapperHolder.find('.tab-btn').removeClass('active');
      $btn.addClass('active');

      this.mapperHolder.find('.tab-content').hide();
      this.mapperHolder.find('#debug-' + $btn.attr('data-tab')).show();
    },

    buildMapperHeader: function($text, $selector)
    {
      var $mc = this.mapperHolder.find($selector);// new Debug_Mapper_Header();
      $mc.find('.debug-header').html($text);
      return $mc;
    },

    buildMapperVar: function($var)
    {
      //console.warn('build var', $var);
      var $id = ($var.nlID === undefined) ? $var.id : $var.nlID;
      var $name = ($var.name === undefined) ? $var.id : $var.name;
      var $iVal = ($var.initialValue === undefined) ? '??' : $var.initialValue;
      var $cVal = ($var.currentValue === undefined) ? '??' : $var.currentValue;
      var $mc = this.$('<div>').addClass('debug-var debug-child').data('varName', $name);//new Debug_Mapper_Var();
      $mc.append(
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Variable Name: ')).append(this.$('<span>').attr('data-mc', 'name_tf').addClass('debug-text').html($name + ' (' + $id + ')')),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Initial Value: ')).append(this.$('<span>').attr('data-mc', 'initial_tf').addClass('debug-text').html($iVal.toString())),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Current Value: ')).append(this.$('<input>').attr('data-mc', 'current_tf').addClass('debug-input').val($cVal.toString())),
        this.$('<button>').attr('data-mc', 'btn_mc').data('mc', $mc).addClass('debug-btn').html('Update Value').on('click', this.onVarClickHandler.bind(this, $name))
      );

      /*$mc.name_tf.text = $var.name + ' (' + $var.id + ')';
      $mc.initial_tf.text = $var.initialValue.toString();
      $mc.current_tf.text = $var.currentValue.toString();
      $mc.varName = $var.name;

      $mc.btn_mc.buttonMode = true;
      $mc.btn_mc.addEventListener(MouseEvent.CLICK, onVarClickHandler, false, 0, true);
      $mc.btn_mc.varName = $var.name;
      $mc.btn_mc.inputTF = $mc.current_tf;*/

      return $mc;
    },

    onVarClickHandler: function($varName, $e)
    {
      var $btn = this.$($e.currentTarget);
      var $var = Scenario.getVariableByName($varName);
      $var.setValue(ScenarioUtils.getValue($btn.data().mc.find('[data-mc=current_tf]').val()));
      //console.log('updateVar', $var);
      this.updateMapper();
    },

    buildMapperItem: function($item)
    {
      var $mc = this.$('<div>').addClass('debug-item debug-child').data('varName', $item.name);//new Debug_Mapper_Item();
      var $convo;
      var $swfName;

      $convo = Scenario.getConversationByID($item.convoID);
      $swfName = ($convo) ? $convo.name : 'Invalid';

      $mc.append(
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Item Name: ')).append(this.$('<span>').attr('data-mc', 'name_tf').addClass('debug-text').html($item.name + ' (' + $item.id + ')')),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('[data-mc]: ')).append(this.$('<span>').attr('data-mc', 'mc_tf').addClass('debug-text').html($item.mcName)),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Parent Convo: ')).append(this.$('<span>').attr('data-mc', 'convo_tf').addClass('debug-text').html($item.convoID + ' (' + $swfName + ')')),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Expected Classes: ')).append(this.$('<span>').attr('data-mc', 'frames_tf').addClass('debug-text').html($item.description)),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Current Class: ')).append(this.$('<input>').attr('data-mc', 'current_tf').addClass('debug-input').val($item.frameNameStr)),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('hasIdle: ')).append(this.$('<span>').attr('data-mc', 'idle_tf').addClass('debug-text').html($item.hasIdleFrame.toString())),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('isPresent: ')).append(this.$('<span>').attr('data-mc', 'present_tf').addClass('debug-text').html($item.isPresent.toString())),
        this.$('<button>').attr('data-mc', 'btn_mc').data('mc', $mc).addClass('debug-btn').html('Update Frame').on('click', this.onItemClickHandler.bind(this, $item.name))
      );

      if (!$item.mcAsset)
      {
        $mc.find('[data-mc=mc_tf]').addClass('missing-asset');
      }

      return $mc;
    },

    onItemClickHandler: function($itemName, $e)
    {
      var $btn = this.$($e.currentTarget);
      var $item = Scenario.getItemByName($itemName);
      var $frameName = $btn.data().mc.find('[data-mc=current_tf]').val();
      //$item.frameName($frameName)
      if ($frameName.indexOf('*') === -1)
      {
        $item.frameName($frameName);
        //$item.frameName = $frameName;
        $item.updateFrames();
      }
      else
      {
        $item.frameName($frameName);
        $item.updateFrames();
        //$item.playFrame($frameName.replace('*', ''));
      }
      this.updateMapper();
    },

    buildMapperLocation: function($location)
    {
      var $mc = this.$('<div>').addClass('debug-location debug-child').data('varName', $location.name);// = new Debug_Mapper_Location();

      $mc.append(
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Location Name: ')).append(this.$('<span>').attr('data-mc', 'name_tf').addClass('debug-text').html($location.name + ' (' + $location.id + ')')),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Activity Html: ')).append(this.$('<span>').attr('data-mc', 'swf_tf').addClass('debug-text').html($location.activitySwf)),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Activity Xml: ')).append(this.$('<span>').attr('data-mc', 'xml_tf').addClass('debug-text').html($location.activityXml)),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Activity JS: ')).append(this.$('<span>').attr('data-mc', 'type_tf').addClass('debug-text').html($location.activityType)),
        this.$('<div>').html(this.$('<span>').addClass('debug-label').html('Performance: ')).append(this.$('<span>').attr('data-mc', 'performance_tf').addClass('debug-text').html($location.performance)),
        this.$('<button>').attr('data-mc', 'btn_mc').data('mc', $mc).addClass('debug-btn').html('Launch Activity').on('click', this.onLocationClickHandler.bind(this, $location.name))
      );

      return $mc;
    },

    onLocationClickHandler: function($locationName, $e)
    {
      //var $btn = $($e.currentTarget);
      //var $item = Scenario.getLocationByName($btn.varName);

      var $dialog = Scenario.getDialogByLocationName($locationName);
      //trace($dialog);
      if ($dialog)
      {
        if ($dialog.parentConvo.id !== this.scenario.activeConversation.id)
        {
          $dialog.parentConvo.begin($dialog, true);
        }
        else
        {
          $dialog.parentConvo.checkDialog($dialog, true);
          //this.scenario.dispatchEvent(new NLEvent(Scenario.SHOW_DIALOG, $dialog));
        }
      }

      //this.updateMapper();
    },

    updateMapper: function()
    {
      if (!this.built || !this._cWindow || !this.mapperHolder)
        return;

      if (!Scenario || !Scenario.singleton)
      {
        this.abortMapper();
        return;
      }
      //.page_tf.text = Page.activePage.name;
      //_mapperMC.view_tf.text = this.scenario.activeConversation.name + ' (' + this.scenario.activeConversation.id + ')';
      ////console.log('updatemapper', this.scenario, this.scenario.activeConversation);
      this.mapperHolder.find('[data-mc=page_tf]').html('See Bugtracker for Page');
      if (this.scenario.activeConversation)
        this.mapperHolder.find('[data-mc=view_tf]').html(this.scenario.activeConversation.name + ' (' + this.scenario.activeConversation.id + ')');

      var $varMC;
      var $itemMC;
      var $locMC;
      var i;

      for (i in this.mapperObj.vars)
      {
        $varMC = this.mapperObj.vars[i];
        $varMC.find('[data-mc=current_tf]').val(Scenario.getVariableValueByName($varMC.data().varName).toString());
      }

      for (i in this.mapperObj.items)
      {
        $itemMC = this.mapperObj.items[i];
        var $item = Scenario.getItemByName($itemMC.data().varName);
        $itemMC.find('[data-mc=current_tf]').val($item.frameNameStr);
        $itemMC.find('[data-mc=present_tf]').html($item.isPresent.toString());
      }

      for (i in this.mapperObj.locations)
      {
        $locMC = this.mapperObj.locations[i];
        var $loc = Scenario.getLocationByName($locMC.data().varName);
        $locMC.find('[data-mc=performance_tf]').html($loc.performance);
      }
    },

    clearMapper: function($close)
    {
      $close = $close === undefined ? false : $close;

      if (!this._cWindow)
        return;

      if (this.mapperHolder)
      {
        this.mapperHolder.find('[data-mc=page_tf]').html('');
        this.mapperHolder.find('[data-mc=view_tf]').html('');
        // while (this.mapperHolder.numChildren > 0)
        // {
        //   this.mapperHolder.removeChildAt(0);
        // }
        this.mapperHolder.find('.child-container').empty();
      }

      this.mapperObj = { };

      if ($close)
        this.closeDebugWin();
    }

  });

  return new ChatmapperDebug();

});

